const criticalFacilitiesAssetLayers = [
 {
  id: 0,
  label: "Affordable and Public Housing Facilities",
  stateVar: "affordableAndPublicHousing",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/1",
 },
 {
  id: 4,
  label: "Community Centers",
  stateVar: "communityCenters",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/4",
 },
 {
  id: 5,
  label: "Correctional Facilities",
  stateVar: "correctionalFacilities",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/5",
 },
 {
  id: 6,
  label: "Disaster Recovery Centers",
  stateVar: "disasterRecoveryCenters",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/6",
 },
 {
  id: 14,
  label: "Electric Production and Supply Facilities",
  stateVar: "electricProdAndSupplyFacilities",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/14",
 },
 {
  id: 10,
  label: "Fire Stations",
  stateVar: "fireStations",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/10",
 },
 {
  id: 7,
  label: "Health Care Facilities",
  stateVar: "healthCareFacilities",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/7",
 },
 {
  id: 11,
  label: "Hospitals",
  stateVar: "hospitals",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/11",
 },
 {
  id: 17,
  label: "Hurricane Debris Staging Sites",
  stateVar: "hurricaneDebrisStagingSites",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/17",
 },
 {
  id: 8,
  label: "Law Enforcement Facilities",
  stateVar: "lawEnforcementFacilities",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/8",
 },
 {
  id: 9,
  label: "Local Government Facilities",
  stateVar: "localGovernmentFacilities",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/9",
 },
 {
  id: 15,
  label: "Military Parcels",
  stateVar: "militaryParcels",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/15",
 },
 {
  id: 13,
  label: "Schools",
  stateVar: "schools",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/13",
 },
 {
  id: 12,
  label: "Schools as Shelters",
  stateVar: "schoolsAsShelters",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/12",
 },
 {
  id: 16,
  label: "Solid Waste and Wastewater Facilities",
  stateVar: "solidWasteAndWastewaterFacilities",
  url: "https://services.arcgis.com/JMAJrTsHNLrSsWf5/arcgis/rest/services/Broward_Critical_Assets/FeatureServer/16",
 },
];

module.exports = { criticalFacilitiesAssetLayers };
